import { cn } from "@/lib/utils"

/**
 * The partner's omniagent, present in the room. The assessment is this
 * employee working — reading the site, asking, reporting — so one identity
 * fronts every step. Gradient and halo derive from the partner accent
 * family, same as the hero mesh.
 */
export function Orb({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "lp-orb relative isolate size-16 shrink-0 overflow-hidden",
        className,
      )}
    >
      <div className="lp-mesh-grain absolute inset-0 rounded-full" />
    </div>
  )
}
